<template>
  <b-card no-body>
    <b-card-header class="p-0" header-bg-variant="primary">
      <div class="row p-0 m-0">
        <div class="col mb-0">
          <h4 class="mt-2 ml-2 font-weight-bold">Chat</h4>
        </div>
        <div class="col mb-0">
          <a href="#" @click="closeChatBox" class="btn float-right text-white">
            <i class="mdi mdi-close"></i>
          </a>
        </div>
      </div>
    </b-card-header>
    <template v-if="sectionTag === 'chatList'">
      <b-list-group flush>
        <b-list-group-item v-if="GetChatMessageList() !== null" href="#" class="flex-column align-items-start" v-for="chat in GetChatMessageList()" :key="chat.roomStayGuestId" @click="changeTag('chatBox', chat)">
          <div class="d-flex w-100 justify-content-between">
            <div>
              <h5 class="font-weight-bold"><b-badge variant="primary">{{chat.roomBedName}}</b-badge> {{chat.userName}}</h5>
            </div>
            <div>
              <small>{{chat.messageDateTime | moment('HH:mm')}}</small>
              <small>{{chat.messageDateTime  | moment('DD-MM-YYYY')}}</small>
            </div>
          </div>

          <div class="d-flex w-100 justify-content-between align-items-center">

            <small class="text-muted text-truncate">{{chat.messageText}}</small>

            <b-avatar v-if="chat.totalUnread !== 0" size="1.5em" variant="primary" :text="chat.totalUnread.toString()"></b-avatar>
          </div>
        </b-list-group-item>

      </b-list-group>

    </template>
    <template v-if="sectionTag === 'chatBox' && selectedMessage !== null">
      <div class="card direct-chat direct-chat-primary">
        <div class="card-header p-0">
          <div class="d-flex flex-row p-0 m-0 align-items-center">
            <a @click="changeTag('chatList', null)" href="#" class="btn pr-0"><i class="mdi mdi-chevron-left mdi-24px"></i></a>
            <!--<div class="d-flex flex-column p-0 m-0">
              <h5>{{selectedMessage.guestName}}</h5>
              <h5><b-badge variant="primary">{{selectedMessage.roomBedName}}</b-badge></h5>
            </div>-->
            <h5 class="font-weight-bold mb-0"><b-badge variant="primary">{{selectedMessage.roomBedName}}</b-badge> {{selectedMessage.userName}}</h5>
          </div>
        </div>
        <chat-box :room-stay-guest-id="selectedMessage.roomStayGuestId" :guest-name="selectedMessage.userName"></chat-box>
      </div>

    </template>
  </b-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from '../EventBus';
  import ChatBox from '../chat/chatBox.vue';
  export default {
    components: {
      ChatBox
    },
    data() {
      return {
        sectionTag: 'chatList',
        selectedMessage: null
      }
    },
    methods: {
      changeTag: function (tag, message) {
        this.sectionTag = tag;
        this.selectedMessage = message;
      },
      closeChatBox: function () {
        EventBus.$emit('closeChatBox');
      }
    },
    computed: {
      ...mapGetters(['GetChatMessageList']),
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chat/chat.vue